import type { SignageOnlineStatus } from 'noddi-async';
import { NoddiBadge, NoddiTooltip } from 'noddi-ui-web';
import { ONLINE_STATUS_DESCRIPTION, ONLINE_STATUS_LABEL, ONLINE_STATUS_VARIANT } from './signageOnlineStatus';

type Props = {
  status: SignageOnlineStatus;
  /** When false, renders the badge without a tooltip (e.g. inside a legend that already explains it). */
  showTooltip?: boolean;
};

export const SignageOnlineStatusBadge = ({ status, showTooltip = true }: Props) => {
  const badge = (
    <NoddiBadge variant={ONLINE_STATUS_VARIANT[status]} withCircle>
      {ONLINE_STATUS_LABEL[status]}
    </NoddiBadge>
  );

  if (!showTooltip) {
    return badge;
  }

  return <NoddiTooltip content={ONLINE_STATUS_DESCRIPTION[status]} trigger={badge} />;
};
